import { render, staticRenderFns } from "./OpinewAppStoreReviewRequestModal.vue?vue&type=template&id=41670446&scoped=true"
import script from "./OpinewAppStoreReviewRequestModal.vue?vue&type=script&lang=js"
export * from "./OpinewAppStoreReviewRequestModal.vue?vue&type=script&lang=js"
import style0 from "./OpinewAppStoreReviewRequestModal.vue?vue&type=style&index=0&id=41670446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41670446",
  null
  
)

export default component.exports